import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DrawColor from '../../components/ExcerciseTypes/DrawColor';


const json = {

  1: { // Exercise num
    unit: 'Unit 7',
    id: 'WB3-U7-P51-E1',
    audio: '',
    video: '',
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page51/E1/Key/answerKey.png',
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page51/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page51/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page51/E1/3.jpg', input: true, answer: "lake" },
        { url: 'img/FriendsPlus/Page51/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page51/E1/5.jpg', input: true, answer: "plane" },
        { url: 'img/FriendsPlus/Page51/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page51/E1/7.jpg', input: true, answer: "gate" },
        { url: 'img/FriendsPlus/Page51/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page51/E1/9.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 7',
    id: 'WB3-U7-P51-E2',
    audio: 'img/FriendsPlus/Page51/Audio/audi-e2-p51.mp3 ',
    video: '',
    textAlign: 'center',
    exerciseKey: 'img/FriendsPlus/Page51/E2/Key/answerKey.png',
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page51/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page51/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page51/E2/3.jpg', audioUrl: 'img/FriendsPlus/Page51/Audio/tieude-e2-p51.mp3' },
        { url: 'img/FriendsPlus/Page51/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page51/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page51/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page51/E2/7.jpg', input: true, answer: "lake" },
        { url: 'img/FriendsPlus/Page51/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page51/E2/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page51/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page51/E2/11.jpg', input: true, answer: "face" },
        { url: 'img/FriendsPlus/Page51/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page51/E2/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page51/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page51/E2/15.jpg', input: true, answer: "cake" },
        { url: 'img/FriendsPlus/Page51/E2/16.jpg' },
      ],


    ]
  },
  3: { // Exercise num
    unit: 'Unit 7',
    id: 'WB3-U7-P51-E3',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page51/E3/Key/answerKey.png',
    // titleQuestion: [{ num: '1', title: 'Circle the correct form of the verb.', color: "#5B5A5D" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'gray' },
          underline: { borderBottom: '2px solid gray' },
          // square: { padding: 3, border: 'solid 2px', borderColor: '#4285F4' },
        },
        // limitSelect: 1,
        listWords: [
          "Open the gate. Here comes a van.",	//0
        ],
        answers: { '0-4': 'circle', '0-12': 'underline' },
        initialValue: {},
      },
      Layout: `
      <div style="line-height: 58px;transform: translateX(50px);">
          <div>
          <img src="img/FriendsPlus/Page51/E3/1.jpg" />
          </div>
        <span style="margin-right:300px">  There is a <u>cat</u> next to the <span style="border: 2px solid gray;padding:3px; border-radius: 50%;">lake</span>  </span>
        <span><input id='0' type='Circle' /></span>
      </div>
      `,
    },
  },
  4: { // Exercise num
    unit: 'Unit 7',
    id: 'WB3-U7-P51-E4',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page51/E4/Key/answerKey.png',
    component: D1,
    checkDuplicated: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page51/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page51/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page51/E4/3.jpg', input: true, answer: "cat/van" },
        { url: 'img/FriendsPlus/Page51/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page51/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page51/E4/6.jpg', input: true, answer: "gate" },
        { url: 'img/FriendsPlus/Page51/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page51/E4/8.jpg', input: true, answer: "cat/van" },
        { url: 'img/FriendsPlus/Page51/E4/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page51/E4/10.jpg' },
      ],

    ]
  },
}
export default json;